<template>
  <div class="scenicParkDetail" :style="{ paddingBottom: (computedDays(detailData.activityEndTime) && detailData.type == 2 && detailData.isEnroll == 1) || detailData.isResident == 1 || computedDays(detailData.activityEndTime) ? '78px' : '0px' }">
    <loading v-if="isLoading"></loading>
    <div v-else>
      <div v-if="!isPageError">
        <div class="banner_container">
          <van-swipe :autoplay="5000" :loop="true" :show-indicators="true" @change="swiperChange('img', $event)">
            <div slot="indicator" class="indicator_box">{{ imgIndex + 1 }} / {{ imgList.length }}</div>
            <van-swipe-item v-for="(item, index) in imgList" :key="index" @click="toAllPic">
              <van-image width="100%" :height="285" :src="item.imageUrl"></van-image>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="desc_container" :class="messageList.length > 0 && momentList.length > 0 ? '' : 'showIntro'">
          <div class="desc_box">
            <div class="desc_left">
              <div class="desc_title">{{ detailData.name }}</div>
              <div class="desc_label_box" v-if="detailData.tag">
                <div class="desc_label" v-for="(item, index) in detailData.tag.split(',')" :key="index">{{ item }}</div>
              </div>
            </div>
            <div class="desc_right">
              <div class="right_top">
                <div class="right_collect" @click="postCollect">
                  <img :src="collectObj.is_collect ? require('../../assets/img/likeAfterIcon.png') : require('../../assets/img/collectBefore_icon.png')" alt="" />
                  <div v-if="Number(collectObj.count) > 0" :style="{ color: collectObj.is_collect ? '#FF504D' : '#262626' }">
                    {{ Number(collectObj.count) >= 10000 ? (Number(collectObj.count) / 10000).toFixed(1) + "w" : Number(collectObj.count) >= 1000 ? (Number(collectObj.count) / 1000).toFixed(1) + "k" : Number(collectObj.count) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="desc_bottom">
            <div class="bottom_item">
              <div class="bottom_icon">
                <img src="../../assets/img/activityName_icon.png" alt="" />
              </div>
              <div class="bottom_title">
                <span class="noWrap">
                  <div class="title">活动主办&nbsp;&nbsp;&nbsp;&nbsp;</div>
                </span>
                <span :style="{ color: 'black' }">{{ detailData.sponsor }}</span>
              </div>
            </div>
            <div class="bottom_item" v-if="(detailData.enrollStartTime && detailData.enrollEndTime && detailData.isEnroll != 2) || detailData.isResident == 1">
              <div class="bottom_icon">
                <img src="../../assets/img/enollTime_icon.png" alt="" />
              </div>
              <div class="bottom_title" v-if="detailData.isResident == 0">
                <div class="title">报名时间&nbsp;&nbsp;&nbsp;&nbsp;</div>
                <span :style="{ color: 'black' }">{{ detailData.enrollStartTime | dateFrmInActivity }} - {{ detailData.enrollEndTime | dateFrmInActivity }}</span>
              </div>
              <div class="bottom_title" v-else>
                <div class="title">报名时间&nbsp;&nbsp;&nbsp;&nbsp;</div>
                <span :style="{ color: 'black' }">常驻活动</span>
              </div>
            </div>
            <div class="bottom_item">
              <div class="bottom_icon">
                <img src="../../assets/img/activity_time_icon.png" alt="" />
              </div>
              <div class="bottom_title" v-if="detailData.isResident == 0">
                <div class="title">活动时间&nbsp;&nbsp;&nbsp;&nbsp;</div>
                <span :style="{ color: 'black' }">{{ detailData.activityStartTime | dateFrmInActivity }} - {{ detailData.activityEndTime | dateFrmInActivity }}</span>
              </div>
              <div class="bottom_title" v-else>
                <div class="title">活动时间&nbsp;&nbsp;&nbsp;&nbsp;</div>
                <span :style="{ color: 'black' }">常驻活动</span>
              </div>
            </div>
            <div class="bottom_item bottom_item_center" v-if="detailData.enrollModel != 1 && detailData.isEnroll == 1 && detailData.enrollLimit > 0">
              <div class="bottom_icon">
                <img src="../../assets/img/person_up.png" alt="" />
              </div>
              <div class="bottom_title">
                <div class="title">上限人数&nbsp;&nbsp;&nbsp;&nbsp;</div>
                <span :style="{ color: 'black' }">{{ detailData.enrollLimit }}人</span>
              </div>
            </div>
            <div class="bottom_item" v-if="detailData.scenicName">
              <div class="bottom_icon">
                <img src="../../assets/img/sen_icon.png" alt="" />
              </div>
              <div class="bottom_title">
                <div class="title">开展景区&nbsp;&nbsp;&nbsp;&nbsp;</div>
                <span :style="{ color: 'black' }">{{ detailData.scenicName }}</span>
              </div>
            </div>
            <div class="bottom_item">
              <div class="bottom_icon">
                <img src="../../assets/img/activityLocation_icon.png" alt="" />
              </div>
              <div class="bottom_title" @click="toMap(detailData)">
                <div class="title">活动地点&nbsp;&nbsp;&nbsp;&nbsp;</div>
                <div class="bottom_right_text">
                  <div :style="{ color: 'black' }">{{ detailData.address }}</div>
                  <div class="img_box">
                    <img src="../../assets/img/nav_icon.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <van-tabs v-model="tabIndex" sticky @click="tabsClick" v-if="messageList.length > 0 || momentList.length > 0">
          <van-tab class="detail_tab" title="活动详情">
            <div class="intro_container">
              <div class="intro_title">活动介绍</div>
              <div class="intro_innerText" :style="{ marginBottom: '30px' }" v-html="detailData.brief"></div>
              <div class="intro_title">活动内容</div>
              <div class="intro_innerText" @click="clickElementVHTML" v-html="detailData.content"></div>
            </div>
          </van-tab>
          <van-tab class="info_tab" title="即时资讯" v-if="messageList.length > 0">
            <div class="realTime_container" v-for="(item, index) in messageList" :key="index">
              <div class="realTime_title">{{ item.title }}</div>
              <div class="realTime_text" :ref="'realTime_text' + index">
                <div class="text" :class="{ text_line: foldArr[index] }" v-html="item.content"></div>
              </div>
              <div v-if="isShowFold[index]" class="fold_text" @click="foldState" :data-index="index">{{ foldArr[index] ? "展开" : "收起" }}</div>
              <div class="realTime_img" v-if="item.imagePath" :style="{ width: '100%', minHeight: '50px' }">
                <van-image :src="item.imagePath" width="100%" height="auto" :style="{ minHeight: '100px' }"></van-image>
              </div>
            </div>
          </van-tab>
          <van-tab class="video_tab" title="精彩瞬间" v-if="momentList.length > 0">
            <div class="pic_container">
              <div class="pic_item" v-for="(item, index) in momentList" :key="index" @click.stop="toAllList(item.id)">
                <van-image v-if="item.type == 0" :radius="3" :src="item.imagePath"></van-image>
                <video @error="listenerError" v-if="item.type == 1" :src="item.imagePath" :poster="item.imageUrl" :data-poster="item.imageUrl"></video>
                <img v-if="item.type == 1" class="video_icon" src="../../assets/img/playVideo_icon.png" alt="" />
              </div>
            </div>
          </van-tab>
        </van-tabs>
        <div class="intro_container" v-else>
          <div class="intro_title">活动介绍</div>
          <div class="intro_innerText" :style="{ marginBottom: '30px' }" v-html="detailData.brief"></div>
          <div class="intro_title">活动内容</div>
          <div class="intro_innerText" @click="clickElementVHTML" v-html="detailData.content"></div>
        </div>
        <!-- {{(computedDays(detailData.activityEndTime,'activityEndTime') || detailData.isResident == 1) && isActEnrollOpen(detailData.enrollStartTime,detailData.enrollEndTime)}}
        {{computedDays(detailData.activityEndTime,'activityEndTime') || detailData.isResident == 1}}
        {{isActEnrollOpen(detailData.enrollStartTime,detailData.enrollEndTime)}} -->
        <div v-if="(computedDays(detailData.activityEndTime, 'activityEndTime') || detailData.isResident == 1) && isActEnrollOpen(detailData.enrollStartTime, detailData.enrollEndTime)">
          <div class="btn_box" v-if="detailData.type == 2 && detailData.isEnroll == 1">
            <!-- 原生报名 -->
            <!-- detailData.userIsEnroll{{detailData.userIsEnroll}}
            detailData.enrollModel{{detailData.enrollModel}} -->
            <div class="btn_primary" v-if="detailData.enrollModel !== 1 && (detailData.userIsEnroll == 2 || !detailData.userIsEnroll)" @click="toEnroll">立即报名</div>
            <!-- 链接报名 -->
            <div class="btn_primary" v-if="detailData.enrollModel == 1 && (detailData.userIsEnroll == 2 || !detailData.userIsEnroll)" @click="toEnrollUrl">立即报名</div>
            <div class="btn_after" v-if="detailData.userIsEnroll == 1">
              <div>已报名</div>
              <div class="time">{{ timeToText(detailData.enrollTime) }}</div>
            </div>
            <div class="btn_stop" v-if="detailData.userIsEnroll == 3">报名已截止</div>
            <!-- <div class="btn_primary" v-else @click="()=>{ this.wxAuth(); }">立即报名</div> -->
          </div>
          <div class="btn_box" v-if="detailData.type == 1">
            <div class="btn_primary" v-if="detailData.isResident == 1 || computedDays(detailData.activityEndTime)" @click="toBuyTicket(detailData.buyTicketAddress)">购买门票</div>
            <!-- <div class="btn_primary btn_end" v-else>活动已结束</div> -->
          </div>
        </div>
        <div v-else-if="!computedDays(detailData.activityEndTime) && detailData.userIsEnroll == 1">
          <div class="btn_box">
            <div class="btn_after">
              <div>已报名</div>
              <div class="time">{{ timeToText(detailData.enrollTime) }}</div>
            </div>
          </div>
        </div>
        <!-- 不在报名时间内但在活动时间内 并且用户未报名-->
        <div v-else-if="!isActEnrollOpen(detailData.enrollStartTime, detailData.enrollEndTime) && isActEnrollOpen(detailData.activityStartTime, detailData.activityEndTime) && detailData.userIsEnroll !== 1 && detailData.isEnroll == 1">
          <!-- 报名时间是否已开始 -->
          <div class="btn_box" v-if="isEnrollStartTime(detailData.enrollStartTime)">
            <div class="btn_stop">报名已截止</div>
          </div>
        </div>
        <!-- 不在报名时间内但在活动时间内 并且用户已报名-->
        <div v-else-if="!isActEnrollOpen(detailData.enrollStartTime, detailData.enrollEndTime) && isActEnrollOpen(detailData.activityStartTime, detailData.activityEndTime) && detailData.userIsEnroll == 1 && detailData.isEnroll == 1">
          <div class="btn_box">
            <div class="btn_after">
              <div>已报名</div>
              <div class="time">{{ timeToText(detailData.enrollTime) }}</div>
            </div>
          </div>
        </div>
        <!-- 判断用户uid是否存在 -->
        <div v-else-if="!uid">
          <div class="btn_box">
            <div class="btn_primary" v-if="detailData.enrollModel !== 1 && (detailData.userIsEnroll == 2 || !detailData.userIsEnroll)" @click="toEnroll">立即报名</div>
          </div>
        </div>
      </div>
      <page-error v-else></page-error>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
// import { Empty } from 'vant';
import LeftImg from "@/components/LeftImgRightText";
import PageError from "../../components/PageError";
import Loading from "@/components/loading";
import { getDistance } from "../../common/common";
import TabCheckout from "@/components/TabCheckout";
import writeComment from "@/components/writeComment.vue";
import customListView from "@/components/customListViewComment.vue";
import displayimage from "@/components/displayImage.vue";
import axios from "axios";
import { fileLengthFormat } from "@/utils/index.js";

// Vue.use(Empty);
export default {
  name: "line_list",
  data() {
    return {
      isPageError: false,
      isLoading: true,
      // 图片数组
      CommentNum: 0, // 评论条数
      commentList: [],
      collectObj: {
        count: 0,
      },
      detailData: {},
      // tabs下标
      tabIndex: 0, // 0 活动详情 1 即时资讯 2 精彩瞬间
      foldArr: [], // 默认不收起，收起状态会影响行数计算(已在循环内做二次处理)
      isShowFold: [], // 是否显示 展开按钮
      messageList: [], // 活动资讯
      momentList: [], // 视频/图片
      imgIndex: 0,
      imgList: [],
      vImageArr: [],
      collectLoading: false,
      uid: "", //用户登陆的uid
    };
  },
  components: {
    // LeftImg,
    Loading,
    PageError,
    // TabCheckout,
  },
  mounted() {
    this.uid = this.$cookie.get("w_uid") || "";
    this.scenicId = this.$route.query.id;
    this.getActivityDetail();
    this.getCollectNum();
    let openid = this.$cookie.get("w_open_id");
    let skey = this.$cookie.get("w_skey");
    let uid = this.$cookie.get("w_uid");
    if (openid && skey && uid) {
      this.getUserInfo(uid, openid, skey);
    }
  },
  methods: {
    isEnrollStartTime(enorllStartTime) {
      let now = new Date().getTime();
      return now - enorllStartTime > 0;
    },
    //判断报名时间是否已开始
    isActEnrollOpen(enorllStartTime, enrollEndTime) {
      let now = new Date().getTime();
      // console.log(new Date(enorllStartTime));
      // console.log(new Date(enrollEndTime));
      // console.log(now - enorllStartTime, "(now - enorllStartTime)");
      // console.log(now - enrollEndTime, "now - enrollEndTime");
      // console.log(Boolean(now - enorllStartTime > 0 && now - enrollEndTime < 0), "Boolean((now - enorllStartTime > 0) && (now - enrollEndTime > 0))");
      if (this.detailData.isResident != 1) {
        return Boolean(now - enorllStartTime > 0 && now - enrollEndTime < 0);
      } else {
        //enorllStartTime 为null 是常驻活动
        return true;
      }
    },
    clickElementVHTML(e) {
      if (e.target.nodeName == "img" || e.target.nodeName == "IMG") {
        wx.previewImage({
          current: e.target.src, // 当前显示图片的http链接
          urls: this.vImageArr, // 需要预览的图片http链接列表
        });
      }
    },
    timeToText(row) {
      if (isNaN(row)) {
        return "";
      }
      var date = new Date(row); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "年";
      var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "月";
      var D = "";
      if (String(date.getDate()).length <= 1) {
        D = "0" + date.getDate() + "日";
      } else {
        D = date.getDate() + "日";
      }
      var h = date.getHours(); //时间的小时数
      if (h < 10) {
        h = "0" + h;
      }
      var m = date.getMinutes(); //时间的分钟数
      if (m < 10) {
        m = "0" + m;
      }
      return Y + M + D + " " + h + ":" + m;
    },
    /**
     * 跳转链接报名
     */
    toEnrollUrl() {
      if (this.uid) {
        window.location.href = this.detailData.enrollUrl;
      } else {
        this.wxAuth();
      }
    },
    toAllPic() {
      let imageList = [];
      for (let i in this.imgList) {
        imageList.push(this.imgList[i].imageUrl);
      }
      this.$router.push({
        name: "newAllVideoPictures",
        query: {
          images: JSON.stringify(imageList),
          video: JSON.stringify([]),
          bannerIndex: this.imgIndex,
        },
      });
    },

    swiperChange(type, event) {
      this.imgIndex = event;
    },
    listenerError(e) {
      e.target.poster = e.target.dataset.poster;
    },

    /**
     * 全部视频/图片
     */
    toAllList(id) {
      let images = [];
      let videos = [];
      let imagesId = [];
      for (let i in this.momentList) {
        // 转换数据格式
        if (this.momentList[i].type == 0) {
          images.push(this.momentList[i].imagePath);
          imagesId.push(this.momentList[i].id);
        } else {
          videos.push({
            videoUrl: this.momentList[i].imagePath,
            videoImage: "",
            id: this.momentList[i].id,
          });
        }
      }
      // 找出index 该对应 值
      let index = 0;
      for (let i in videos) {
        if (videos[i].id == id) {
          index = i;
        }
      }
      for (let i in images) {
        if (imagesId[i] == id) {
          index = Number(videos.length) + Number(i);
        }
      }
      this.$router.push({
        name: "newAllVideoPictures",
        query: {
          images: JSON.stringify(images),
          video: JSON.stringify(videos),
          bannerIndex: index,
          currentTime: 0,
          muted: 0,
          isPlay: true,
        },
      });
    },

    /**
     * 循环判断即时资讯行数 设置展开或者收起状态
     */
    loopJudjeLine() {
      for (let i in this.foldArr) {
        let rowNum = Math.round($(this.$refs[`realTime_text${i}`]).height() / parseFloat($(this.$refs[`realTime_text${i}`]).css("line-height")));
        this.isShowFold[i] = rowNum > 3;
        this.foldArr[i] = true; // 默认为可展开状态
      }
      this.$forceUpdate();
    },

    /** tabs切换 */
    tabsClick(name, title) {
      if (name == 1) {
        // 即时资讯
        this.$nextTick(() => {
          this.loopJudjeLine();
        });
      } else {
        for (let i in this.foldArr) {
          // 切换重置状态，用于避免计算行数错误
          this.foldArr[i] = false;
        }
      }
    },

    /**
     * 展开/收起
     */
    foldState(event) {
      let index = event.currentTarget.dataset.index;
      this.foldArr[index] = !this.foldArr[index];
      this.$forceUpdate();
    },

    toMap(item) {
      item.address = item.address ? item.address : " ";
      this.openLocation(item.latitude, item.longitude, item.name, item.address);
    },
    /**
     * 获取用户信息
     * @params skey openid uid
     */
    getUserInfo(uid, openId, skey) {
      console.log("发起请求");
      let data = new FormData();
      data.append("uid", uid);
      data.append("open_id", openId);
      data.append("skey", skey);
      this.$request
        .post(`/appserver/v1/user/get_auth_data`, data)
        .then((res) => {
          if (res.data.ret == 0) {
            localStorage.setItem("uid", res.data.data.uid);
            localStorage.setItem("userName", res.data.data.nickname);
            localStorage.setItem("userImg", res.data.data.head_img_url);
            localStorage.setItem("mobile", res.data.data.mobile);
            sessionStorage.setItem("userName", res.data.data.nickname);
            sessionStorage.setItem("userImg", res.data.data.head_img_url);
            // 如果手机号为空，跳转绑定手机号页面
            if (!res.data.data.mobile) {
              this.$router.replace({
                name: "bindingPhone",
              });
            }
          } else if (res.data.ret == 1) {
            // 登录过期
            if (res.data.errorcode == 20012) {
              localStorage.removeItem("uid");
              localStorage.removeItem("userName");
              localStorage.removeItem("userImg");
              localStorage.removeItem("mobile");
              sessionStorage.removeItem("userName");
              sessionStorage.removeItem("userImg");
              this.wxAuth();
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    /**
     * 购买门票
     */
    toBuyTicket(url) {
      window.location.href = url;
    },

    /**
     * 立即报名
     */
    toEnroll() {
      if (this.uid) {
        this.$router.push({
          path: "/enroll",
          query: {
            id: this.scenicId,
            remark: this.detailData.enrollRemarks,
          },
        });
      } else {
        this.wxAuth();
      }
    },

    /**
     * 获取收藏数量/收藏状态
     */
    getCollectNum() {
      this.$request
        .get(`/appserver/v1/collect/is/collect?srcType=activity&srcId=${this.scenicId}`)
        .then((res) => {
          if (res.data.ret == 0) {
            let resData = res.data.data;
            this.collectObj = resData;
          }
        })
        .catch((e) => {});
    },

    /**
     * 提交收藏
     */
    postCollect() {
      if (this.collectLoading) {
        return false;
      }
      this.collectLoading = true;
      // 未登录情况
      if (!this.$cookie.get("w_uid")) {
        if (this.$cookie.get("w_uid") == 0) {
          // 登录了未绑定手机号
          this.$router.push({
            name: "bindingPhone",
            query: {
              for: "other",
            },
          });
        } else {
          // 未登录
          this.wxAuth();
        }
        return;
      }
      let data = new FormData();
      data.append("srcType", "activity");
      data.append("srcId", this.scenicId);
      if (this.collectObj.is_collect) {
        this.$request
          .post(`/appserver/v1/collect/cancel`, data)
          .then((res) => {
            if (res.data.ret == 0) {
              this.$toast("取消收藏!");
              this.collectObj.is_collect = 0;
              this.collectObj.count = Number(this.collectObj.count) - 1;
              this.collectLoading = false;
            } else {
              this.$toast("取消收藏失败");
              this.collectLoading = false;
            }
          })
          .catch((e) => {});
      } else {
        this.$request
          .post(`/appserver/v1/collect/save`, data)
          .then((res) => {
            if (res.data.ret == 0) {
              this.$toast("收藏成功!");
              this.collectObj.is_collect = 1;
              this.collectObj.count = Number(this.collectObj.count) + 1;
              this.collectLoading = false;
            } else {
              this.$toast("收藏失败");
              this.collectLoading = false;
            }
          })
          .catch((e) => {});
      }
    },

    /**
     * 计算天数
     */
    computedDays(endTime, type) {
      let startTime = new Date().getTime();
      let utc = endTime - startTime;
      console.log(utc >= 0, type);
      return utc >= 0;
    },
    /**
     * 循环添加video事件监听
     */
    loopAddEventForVideo(target) {
      target.addEventListener("waiting", function(e) {
        console.log("视频正在加载中");
        let target = e.target;
        let video_shadow_target = $(target)
          .next()
          .get(0);
      });
      target.addEventListener("pause", function(e) {
        console.log("视频暂停播放");
        let target = e.target;
        let video_shadow_target = $(target)
          .next()
          .get(0);
        video_shadow_target.style.display = "block";
        video_shadow_target.style.zIndex = "9999999";
      });
      target.addEventListener("ended", function(e) {
        console.log("视频停止");
        let target = e.target;
        let video_shadow_target = $(target)
          .next()
          .get(0);
        video_shadow_target.style.display = "block";
        video_shadow_target.style.zIndex = "9999999";
      });
      target.addEventListener("error", function(e) {
        console.log("视频出错");
        $(".video_shadow").show();
      });
      target.addEventListener("playing", function(e) {
        console.log(e, "eeeeeee");
        let target = e.target;
        let video_shadow_target = $(target)
          .next()
          .get(0);
        video_shadow_target.style.height = this.videoHeight;
        // video_shadow_target.style.display = 'none';
        video_shadow_target.style.zIndex = "0111";
        console.log("视频开始正常播放");
      });
    },

    /**
     * 获取活动详情数据
     */
    getActivityDetail() {
      axios
        .create({
          baseURL: this.newUrlHost,
          headers: {},
          withCredentials: true,
        })
        .get(`/appserver/v1/activity/detial?id=${this.scenicId}`)
        .then((res) => {
          if (res.data.ret == 0) {
            let resData = res.data.data;
            this.isLoading = false;
            this.detailData = resData;
            this.uid = this.$cookie.get("w_uid");
            if (resData.galleryVos) {
              this.imgList = resData.galleryVos;
            }
            if (resData.messag && resData.messag.length > 0) {
              let brief = "";
              for (let i in resData.messag) {
                brief = resData.messag[i].content;
                brief = brief.replace(/\n/g, "<br>");
                brief = brief.replace(/\s/g, "&nbsp;");
                this.foldArr.push(false);
                this.isShowFold.push(true);
                resData.messag[i].content = brief;
              }
              this.messageList = resData.messag;
            }
            /* eslint-disable */
            let imgUrls = resData.content.match(/<img\b.*?(?:\>|\/>)/gi);
            for (let k in imgUrls) {
              /* eslint-disable */
              this.vImageArr.push(imgUrls[k].match(/\bsrc\b\s*=\s*[\'\"]?([^\'\"]*)[\'\"]?/i)[1]);
            }
            this.$nextTick(() => {
              // 获取全部video 并且添加属性
              let targets = document.querySelectorAll(".intro_innerText video");
              let p_targets = document.querySelectorAll(".intro_innerText .video-wrapper");
              let videoWidth = [];
              let videoHeight = [];
              let promiseArr = [];
              for (let k in targets) {
                if (typeof targets[k] == "object") {
                  targets[k].setAttribute("playsinline", "true");
                  targets[k].setAttribute("webkit-playsinline", "true");
                  targets[k].setAttribute("x5-video-player-type", "h5-page");
                  targets[k].setAttribute("poster", `${require("@/assets/img/video_default.png")}`);
                  targets[k].setAttribute("preload", "none");
                  targets[k].setAttribute("controlsList", "nodownload noremoteplayback"); // 控制contril按钮的显示隐藏
                  targets[k].setAttribute("disablePictureInPicture", ""); //关闭画中画按钮
                  p_targets[k].style = "";
                }
              }
              // let dom = document.createElement('div');
              // dom.className = 'video_shadow';
              // fileLengthFormat
              // Promise.all(promiseArr).then(res => {

              //   循环给 p 标签添加自定义dom元素
              //   for (let k in p_targets) {
              //     if ((typeof p_targets[k]) == 'object') {
              //       dom.style.width = videoWidth[k] + 'px';
              //       console.log(videoHeight, 'videoHeight')
              //       dom.style.height = videoHeight[k] + 'px';
              //       dom.style.top = 0;
              //       dom.addEventListener('click', () => {
              //         console.log('点击到遮罩层')
              //         targets[k].play();
              //       })
              //       p_targets[k].appendChild(dom);
              //     }
              //   }
              // });
            });
            if (resData.moment && resData.moment.length > 0) {
              this.momentList = resData.moment;
            }
            setTimeout(() => {
              this.shareInit();
            }, 300);
          } else {
            if (res.data.errorcode == 500) {
              // 景区已下线
              this.$router.replace({
                name: "404",
              });
            } else {
              this.isLoading = false;
              this.isPageError = true;
            }
          }
        })
        .catch((e) => {
          this.isLoading = false;
          this.isPageError = true;
        });
    },

    /**
     * 初始化分享事件
     */
    shareInit() {
      wx.ready(() => {
        // eslint-disable-next-line
        //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          title: this.detailData.shareInfo.title, // 分享标题
          desc: this.detailData.shareInfo.content, // 分享描述
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.detailData.shareInfo.pic, // 分享图标
          success: function() {},
        });
        wx.updateTimelineShareData({
          title: this.detailData.shareInfo.title, // 分享标题
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.detailData.shareInfo.pic,
          success: function() {},
        });
      });
      wx.error(function(res) {});
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.intro_innerText {
  /*video默认aduio音量按钮*/
  /deep/video::-webkit-media-controls-mute-button {
    display: none !important;
  }
  /*video默认setting按钮*/
  /deep/video::-internal-media-controls-overflow-button {
    display: none !important;
  }
  //音量按钮
  /deep/video::-webkit-media-controls-mute-button {
    display: none;
  }
  /deep/video::-webkit-media-controls-toggle-closed-captions-button {
    display: none;
  }
  //音量的控制条
  /deep/video::-webkit-media-controls-volume-slider {
    display: none;
  }

  /deep/.video-wrapper {
    position: relative;
    video {
      position: relative;
      z-index: 999;
      object-fit: fill;
    }
  }
  /deep/.video_shadow {
    position: absolute;
    background: rgba(0, 0, 0, 0.3);
    z-index: 99999999999;
    // transform: translateY(-50%);
    // height: 50px;
  }
}

.scenicParkDetail {
  padding-bottom: 78px;

  /deep/.van-tab__text {
    color: #787878;
    font-size: 16px;
  }
  /deep/.van-tab--active {
    .van-tab__text {
      font-weight: bold;
      color: #262626;
    }
  }
  /deep/.van-tabs__line {
    width: 20px;
    height: 4px;
    background: #2ed07e;
    border-radius: 2px;
  }
  /deep/.van-tabs__nav {
    // padding: 0 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 10px;
  }
  /deep/.van-tab {
    flex: none;
    padding-left: 0px;
    padding-right: 0px;
    margin-right: 30px;
  }

  .realTime_container {
    padding: 0px 20px;
    color: #262626;
    .realTime_title {
      font-size: 18px;
      font-weight: bold;
      margin: 20px 0px 15px 0px;
    }
    .realTime_text {
      font-size: 14px;
      color: #787878;
      line-height: 20px;
    }
    .fold_text {
      font-size: 13px;
      color: #2eba73;
    }
    .text_line {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box; //将对象作为弹性伸缩盒子模型显示
      -webkit-line-clamp: 3; //控制显示几行文字
      -webkit-box-orient: vertical; //设置伸缩盒对象的子元素排列方式
    }
    .realTime_img {
      margin: 20px 0px;
    }
  }

  .pic_container {
    width: 100%;
    padding: 5px 20px;
    box-sizing: border-box;
    & > div:nth-child(even) {
      // 偶数
      padding-left: 7.5px;
    }
    & > div:nth-child(odd) {
      // 奇数
      padding-right: 7.5px;
    }
    & > .pic_item {
      display: inline-block;
      width: 50%;
      box-sizing: border-box;
      padding: 7.5px 0px;
      height: 175px; // 160 + 15
      position: relative;
      // overflow: hidden;
      .van-image {
        width: 100%;
        height: 100%;
        border-radius: 3px;
      }
      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 3px;
      }
      .video_icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 60px;
        height: 60px;
      }
    }
  }

  .banner_container {
    position: relative;
    width: 100%;
    min-height: 234px;
    // background: gray;
    .video_ele {
      width: 100%;
      height: 234px;
      object-fit: fill;
    }
    .indicator_box {
      position: absolute;
      bottom: 20px;
      right: 20px;
      color: white;
      padding: 2px 8px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 10px;
    }
  }

  .desc_container {
    padding: 10px 20px 30px 20px;
    // border-bottom: 5px solid rgba(0, 0, 0, 0.05);
    border-radius: 12px 12px 0px 0px;
    transform: translateY(-10px);
    background: white;
    .live_box {
      margin: 60px 0px 30px 0px;
      height: 130px;
      background: linear-gradient(270deg, rgba(176, 3, 71, 0) 0%, rgba(176, 3, 71, 1) 100%), url("../../assets/img/likeAfterIcon.png");
      // background-image:url('../../assets/img/likeAfterIcon.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      border-radius: 0px 3px 3px 0px;
      position: relative;
      .top_info {
        position: absolute;
        top: 0;
        left: 0;
        height: 24px;
        padding: 0 10px;
        background: #8f70ff;
        color: white;
        line-height: 24px;
        border-radius: 3px 0px 14px 0px;
        font-size: 12px;
      }
      .top_bottom {
        position: absolute;
        bottom: 20px;
        left: 0;
        font-size: 15px;
        color: white;
        padding-left: 20px;
        .bottom_top {
          font-weight: bold;
        }
        .bottom_desc {
          font-size: 12px;
        }
      }
    }
    .desc_box {
      display: flex;
      justify-content: space-between;
      .desc_left {
        padding-top: 20px;
      }
      .desc_right {
        .right_top {
          display: flex;
          .right_collect {
            display: flex;
            align-items: flex-start;
            div {
              font-size: 12px;
              color: #262626;
              margin-left: 2px;
            }
          }
          img {
            width: 24px;
            height: 24px;
            vertical-align: top;
            margin-left: 20px;
          }
        }
      }
    }
    .desc_title {
      font-size: 24px;
      color: #262626;
      font-weight: 700;
    }
    .desc_label_box {
      margin-top: 10px;
      .desc_label {
        padding: 2px 5px;
        background: rgba(97, 69, 247, 0.15);
        color: #6145f7;
        display: inline-block;
        margin-right: 5px;
        font-size: 11px;
      }
    }
    .desc_bottom {
      display: flex;
      flex-direction: column;
      // align-items: center;
      justify-content: center;
      margin-top: 30px;
      background: rgba(46, 186, 115, 0.08);
      padding-top: 20px;
      padding-left: 22px;
      padding-right: 20px;
      border-radius: 1px;
      .bottom_item {
        display: flex;
        font-size: 14px;
        margin-bottom: 20px;
        // align-items: center;
        div {
          display: inline-block;
        }
        .bottom_icon {
          // display: flex;
          // align-items: center;
          transform: translateY(3px);
          img {
            width: 16px;
            height: 16px;
          }
        }
        .bottom_title {
          color: #787878;
          margin-left: 13px;
          margin-right: 15px;
          display: flex;
          // align-items: center;
          .title {
            white-space: nowrap;
          }
          .noWrap {
            white-space: nowrap;
          }
        }
        .bottom_right_text {
          display: flex;
          align-items: center;
          .img_box {
            border-left: 1px solid #dedede;
            margin-left: 5px;
            > img {
              width: 22px;
              height: 22px;
            }
          }
        }
        // .bottom_location {
        //   .title {
        //     width: 30%;
        //   }
        //   .content {
        //     width: 70%;
        //   }
        // }
        .bottom_content {
          color: #262626;
        }
      }
      .bottom_item_center {
        // align-items: center;
        .bottom_title {
          // align-items: center;
          height: 16px;
          line-height: 16px;
        }
      }
    }
  }

  .intro_container {
    padding: 30px 20px;
    color: #262626;

    .intro_title {
      font-size: 20px;
      font-weight: 700;
    }
    .intro_innerText {
      font-size: 14px;
      color: #787878;
      margin-top: 10px;
      // line-height: 20px;
      /deep/img {
        width: 100% !important;
        height: auto !important;
      }
      /deep/p {
        margin: 10px 0px;
        font-size: 15px;
        color: black;
        letter-spacing: 0.5px;
      }
      /deep/p {
        margin: 10px 0px;
        font-size: 15px;
        color: black;
        letter-spacing: 0.5px;
      }
      /deep/p {
        margin: 10px 0px;
        font-size: 15px;
        color: black;
        letter-spacing: 0.5px;
      }
      /deep/p {
        margin: 10px 0px;
        font-size: 15px;
        color: black;
        letter-spacing: 0.5px;
      }
      /deep/p {
        margin: 10px 0px;
        font-size: 15px;
        color: black;
        letter-spacing: 0.5px;
      }
      /deep/p {
        margin: 10px 0px;
        font-size: 15px;
        color: black;
        letter-spacing: 0.5px;
      }
      /deep/p {
        margin: 10px 0px;
        font-size: 15px;
        color: black;
        letter-spacing: 0.5px;
      }
      /deep/p {
        margin: 10px 0px;
        font-size: 15px;
        color: black;
        letter-spacing: 0.5px;
      }
      /deep/p {
        margin: 10px 0px;
        font-size: 15px;
        color: black;
        letter-spacing: 0.5px;
      }
      /deep/p {
        margin: 10px 0px;
        font-size: 15px;
        color: black;
        letter-spacing: 0.5px;
      }
      /deep/p {
        margin: 10px 0px;
        font-size: 15px;
        color: black;
        letter-spacing: 0.5px;
      }
      /deep/p {
        margin: 10px 0px;
        font-size: 15px;
        color: black;
        letter-spacing: 0.5px;
      }
      //   width: 200px;
    }
    // padding-bottom: 70px;
  }

  .btn_box {
    padding: 18px 20px;
    display: flex;
    justify-content: center;
    // border-top: 1px solid rgba(0, 0, 0, 0.05);
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    background: white;
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);
    z-index: 1000000000000;
    .btn_primary {
      width: 95%;
      height: 42px;
      line-height: 42px;
      font-size: 15px;
      color: white;
      text-align: center;
      background: #2eba73;
    }
    .btn_end {
      background: #dedede;
      color: white;
    }
    .btn_after {
      width: 95%;
      height: 42px;
      // line-height: 42px;
      font-size: 14px;
      color: #2eba73;
      text-align: center;
      background: #f2f2f2;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .time {
        font-size: 12px;
        color: #999;
      }
    }
    .btn_stop {
      width: 95%;
      height: 42px;
      line-height: 42px;
      font-size: 15px;
      color: #bfbfbf;
      text-align: center;
      background: #f2f2f2;
    }
  }
  .showIntro {
    padding-bottom: 0px;
  }
  .info_tab {
    min-height: calc(100vh - 74px);
  }
  .video_tab {
    min-height: calc(100vh - 44px);
  }
  .detail_tab {
    min-height: calc(100vh - 44px);
  }
}
</style>
